function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { useQuery, useQueryClient, useMutation } from 'react-query';
import axios from 'axios';
import { API_PREFIX_URL, CACHE_KEYS } from './config';
import { api } from './swaggerApi';
var PROJECTS_CONTROLLER = 'projects';
export var RecurrentProjectAPI = {
    show: function() {
        var _ref = _async_to_generator(function(projectIdentifier) {
            var url;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        url = "".concat(API_PREFIX_URL, "/").concat(PROJECTS_CONTROLLER, "/").concat(projectIdentifier, "/schedule");
                        return [
                            4,
                            axios.get(url)
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return function(projectIdentifier) {
            return _ref.apply(this, arguments);
        };
    }(),
    update: function() {
        var _ref = _async_to_generator(function(projectIdentifier, params) {
            var url;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        url = "".concat(API_PREFIX_URL, "/").concat(PROJECTS_CONTROLLER, "/").concat(projectIdentifier, "/update_schedule");
                        return [
                            4,
                            axios.put(url, params)
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return function(projectIdentifier, params) {
            return _ref.apply(this, arguments);
        };
    }(),
    costs: function() {
        var _ref = _async_to_generator(function(projectIdentifier) {
            var url;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        url = "".concat(API_PREFIX_URL, "/").concat(PROJECTS_CONTROLLER, "/").concat(projectIdentifier, "/project_costs");
                        return [
                            4,
                            axios.get(url)
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return function(projectIdentifier) {
            return _ref.apply(this, arguments);
        };
    }(),
    estimateNextLaunch: function() {
        var _ref = _async_to_generator(function(projectIdentifier, settings) {
            var url;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        url = "".concat(API_PREFIX_URL, "/").concat(PROJECTS_CONTROLLER, "/").concat(projectIdentifier, "/estimate_next_launch");
                        return [
                            4,
                            axios.post(url, settings)
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return function(projectIdentifier, settings) {
            return _ref.apply(this, arguments);
        };
    }()
};
/*
 *  Show Project
 */ export var useRecurringProject = function(projectIdentifier) {
    return useQuery([
        CACHE_KEYS.RECURRING_PROJECTS,
        projectIdentifier
    ], /*#__PURE__*/ _async_to_generator(function() {
        var data;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        RecurrentProjectAPI.show(projectIdentifier)
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    }), {
        enabled: !!projectIdentifier,
        keepPreviousData: true
    });
};
/*
 *  Update Project Schedule
 */ export var useUpdateProjectSchedule = function(projectIdentifier) {
    var queryClient = useQueryClient();
    return useMutation(function() {
        var _ref = _async_to_generator(function(params) {
            var data;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            RecurrentProjectAPI.update(projectIdentifier, {
                                project_schedule: params
                            })
                        ];
                    case 1:
                        data = _state.sent().data;
                        return [
                            2,
                            data
                        ];
                }
            });
        });
        return function(params) {
            return _ref.apply(this, arguments);
        };
    }(), {
        onSuccess: function(res) {
            queryClient.setQueryData([
                CACHE_KEYS.RECURRING_PROJECTS,
                projectIdentifier
            ], res);
        }
    });
};
export var useGetRecurrentProjectCosts = function(projectIdentifier) {
    return useQuery([
        CACHE_KEYS.PROJECT_COSTS,
        projectIdentifier
    ], /*#__PURE__*/ _async_to_generator(function() {
        var data;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        RecurrentProjectAPI.costs(projectIdentifier)
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    }), {
        keepPreviousData: true
    });
};
export var useEstimateNextLaunch = function(param) {
    var projectIdentifier = param.projectIdentifier, settings = param.settings;
    var _ref = settings || {}, end_date = _ref.end_date, end_type = _ref.end_type, repeat_type = _ref.repeat_type, repeat_cadence = _ref.repeat_cadence, repeat_on = _ref.repeat_on;
    var queryKeys = {
        end_date: end_date,
        end_type: end_type,
        repeat_type: repeat_type,
        repeat_cadence: repeat_cadence,
        repeat_on: repeat_on
    };
    return useQuery([
        CACHE_KEYS.NEXT_LAUNCH_ESTIMATES,
        _object_spread({}, queryKeys)
    ], /*#__PURE__*/ _async_to_generator(function() {
        var data, _ref, valid_next_launch, next_for_cadence;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        RecurrentProjectAPI.estimateNextLaunch(projectIdentifier, {
                            project_schedule: settings
                        })
                    ];
                case 1:
                    data = _state.sent().data;
                    _ref = data || {}, valid_next_launch = _ref.valid_next_launch, next_for_cadence = _ref.next_for_cadence;
                    return [
                        2,
                        {
                            nextLaunchValid: !!valid_next_launch,
                            nextLaunchEstimated: valid_next_launch,
                            nextLaunchForCadence: next_for_cadence
                        }
                    ];
            }
        });
    }), {
        keepPreviousData: true,
        enabled: !!projectIdentifier && !!settings,
        // Given the same schedule settings (defined by queryKeys) -> cache the validation result for 5 minutes
        staleTime: 1000 * 60 * 5
    });
};
export var useProjectWaves = function(projectIdentifier, limit) {
    return useQuery([
        CACHE_KEYS.PROJECT_WAVES,
        projectIdentifier
    ], /*#__PURE__*/ _async_to_generator(function() {
        var data;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api.insightsPlatform.projectsWavesDetail(_object_spread({
                            identifier: projectIdentifier
                        }, limit && {
                            limit: limit
                        }))
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    }), {
        enabled: !!projectIdentifier
    });
};
